module.exports = __webpack_public_path__ + "img/tutorial_guideChat_04.f7d88c96.png";